var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV2OrderpayStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0312 26.2206C18.3063 26.2206 17.7726 25.9085 17.4302 25.2841C17.0878 24.6598 17.0979 24.0456 17.4604 23.4414L27.55 7.31019C27.8722 6.7463 28.3757 6.46436 29.0604 6.46436C29.7451 6.46436 30.2486 6.7463 30.5708 7.31019L40.6604 23.4414C41.0229 24.0456 41.033 24.6598 40.6906 25.2841C40.3483 25.9085 39.8146 26.2206 39.0896 26.2206H19.0312ZM42.6542 53.1664C39.6736 53.1664 37.1764 52.1595 35.1625 50.1456C33.1486 48.1317 32.1417 45.6345 32.1417 42.6539C32.1417 39.6734 33.1486 37.1762 35.1625 35.1623C37.1764 33.1484 39.6736 32.1414 42.6542 32.1414C45.6347 32.1414 48.1319 33.1484 50.1458 35.1623C52.1597 37.1762 53.1667 39.6734 53.1667 42.6539C53.1667 45.6345 52.1597 48.1317 50.1458 50.1456C48.1319 52.1595 45.6347 53.1664 42.6542 53.1664ZM9.0625 51.656C8.53889 51.656 8.1059 51.4848 7.76354 51.1425C7.42118 50.8001 7.25 50.3671 7.25 49.8435V35.1019C7.25 34.5782 7.42118 34.1453 7.76354 33.8029C8.1059 33.4605 8.53889 33.2894 9.0625 33.2894H23.8042C24.3278 33.2894 24.7608 33.4605 25.1031 33.8029C25.4455 34.1453 25.6167 34.5782 25.6167 35.1019V49.8435C25.6167 50.3671 25.4455 50.8001 25.1031 51.1425C24.7608 51.4848 24.3278 51.656 23.8042 51.656H9.0625Z",
    fill: "#6b7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2OrderpayStandard);
export default __webpack_public_path__ + "static/media/v2-orderpay-standard.8f2ab91224c19ff920bd64a44edd8e57.svg";
export { ForwardRef as ReactComponent };